// extracted by mini-css-extract-plugin
export default {"root":"DataGrid_root__XFOvr","noResultsRoot":"DataGrid_noResultsRoot__LULGp"};